import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';

/**
 * @group Avatar
 * @component Avatar
 * @description Standard avatar component with different sizes
 */
@Component({
  selector: 'la-avatar',
  template: `
    <div class="la-avatar" (click)="onClick()"
         [ngClass]="{'la-avatar--x-small': size === 'xsm',
         'la-avatar--small': size === 'sm',
         'la-avatar--medium': size === 'md',
         'la-avatar--large': size === 'large',
         'la-avatar--x-large': size === 'xlarge'}">
      <la-image [src]="src"></la-image>
    </div>
  `,
  styles: [`
    .la-avatar{height:64px;width:64px;vertical-align:middle;overflow:hidden;border-radius:50%;float:left}.la-avatar--x-small{height:32px;width:32px}.la-avatar--small{height:48px;width:48px}.la-avatar--medium{height:64px;width:64px}.la-avatar--large{width:88px;height:88px}.la-avatar--x-large{width:264px;height:264px}
  `],
  encapsulation: ViewEncapsulation.None
})
export class LaAvatarComponent {
  private _src: string;
  private _size = 'md';
  @Output() clicked: EventEmitter<any> = new EventEmitter();

  onClick() {
    this.clicked.next();
  }

  get src(): string {
    return this._src;
  }

  /**
   * path - to set image url
   */
  @Input()
  set src(src: string) {
    this._src = src;
  }

  /**
   * size of various size option of avatar: sm
   * md is default size
   */
  @Input()
  set size(name: string) {
    this._size = name.toLowerCase();
  }


  get size(): string {
    return this._size;
  }
}
